/**
 * Returns the hourly rate based on weekly hours.
 * Rate table per business rules.
 */
export function getTarifHoraire(heuresHebdo) {
  const h = parseFloat(heuresHebdo) || 0;
  if (h >= 50) return 7.90;
  if (h >= 45) return 8.00;
  if (h >= 40) return 8.50;
  if (h >= 35) return 9.00;
  if (h >= 30) return 9.50;
  if (h >= 21) return 10.00;
  if (h >= 10) return 10.50;
  if (h >= 3) return 11.00;
  return 0;
}

/**
 * Monthly lissed hours: weekly_hours × 47 / 12
 */
export function getHeuresLissees(heuresHebdo) {
  const h = parseFloat(heuresHebdo) || 0;
  return (h * 47) / 12;
}

/**
 * Monthly amount = lissed hours × hourly rate
 */
export function getMontantMensuel(heuresHebdo) {
  const lissees = getHeuresLissees(heuresHebdo);
  const tarif = getTarifHoraire(heuresHebdo);
  return lissees * tarif;
}

/**
 * Parse "HH:MM" to decimal hours (e.g. "08:30" → 8.5)
 */
export function timeToDecimal(timeStr) {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(':').map(Number);
  return h + (m || 0) / 60;
}

/**
 * Calculate total weekly hours from a day schedule object:
 * { lundi: { debut, fin, active }, mardi: ..., ... }
 */
export function calcHeuresHebdo(schedule) {
  const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi'];
  let total = 0;
  for (const day of days) {
    const d = schedule[day];
    if (!d || !d.active) continue;
    const debut = timeToDecimal(d.debut);
    const fin = timeToDecimal(d.fin);
    if (fin > debut) total += fin - debut;
  }
  return total;
}

/**
 * Format a decimal hour count to "Xh YYmin"
 */
export function formatHeures(decimal) {
  if (!decimal) return '0h';
  const h = Math.floor(decimal);
  const m = Math.round((decimal - h) * 60);
  if (m === 0) return `${h}h`;
  return `${h}h ${String(m).padStart(2, '0')}min`;
}

/**
 * Format amount in euros
 */
export function formatMontant(amount) {
  if (amount === null || amount === undefined) return '—';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(amount);
}

/**
 * Get statut badge class
 */
export function getStatutBadgeClass(statut) {
  const map = {
    actif: 'badge-green',
    accepte: 'badge-green',
    paye: 'badge-green',
    approuve: 'badge-green',
    en_cours: 'badge-blue',
    en_attente: 'badge-orange',
    valide_n1: 'badge-blue',
    retard: 'badge-red',
    parti: 'badge-gray',
    refuse: 'badge-red',
    expire: 'badge-gray',
    termine: 'badge-gray',
    suspendu: 'badge-orange',
    rembourse: 'badge-gray',
    acquis: 'badge-green',
    verse: 'badge-blue',
  };
  return map[statut] || 'badge-gray';
}

/**
 * French label for statut
 */
export function getStatutLabel(statut) {
  const map = {
    actif: 'Actif',
    accepte: 'Accepté',
    paye: 'Payé',
    approuve: 'Approuvé',
    en_cours: 'En cours',
    en_attente: 'En attente',
    valide_n1: 'Validé par Chloé — en attente direction',
    retard: 'En retard',
    parti: 'Parti',
    refuse: 'Refusé',
    expire: 'Expiré',
    termine: 'Terminé',
    suspendu: 'Suspendu',
    rembourse: 'Remboursé',
    acquis: 'Acquis',
    verse: 'Versé',
  };
  return map[statut] || statut;
}

export const MOIS_NOMS = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
];
